'use client';

import { Button } from '@shared/shared-shadcn-ui';
import { cn } from '@shared/shared-utils';
import { PropsWithChildren } from 'react';

type Properties = {
  onClick?: () => void;
  isDisabled?: boolean;
  className?: string;
} & PropsWithChildren;

const FormButton = ({
  onClick,
  isDisabled,
  children,
  className,
}: Properties) => {
  return (
    <Button
      disabled={isDisabled}
      onClick={onClick}
      className={cn(
        'flex items-center justify-center h-auto bg-ogn-blue hover:bg-ogn-blue/90 text-[22px] lg:text-[24px] font-bold text-ogn-white py-2',
        'leading-normal font-roboto rounded-[34px]',
        isDisabled && 'bg-[#63666B] hover:bg-[#63666B] !opacity-100',
        className,
      )}
    >
      {children}
    </Button>
  );
};

export { FormButton };
